module.exports = __webpack_public_path__ + "img/wordle-haze.4730ff88.svg";